<template>
    <div class="d-inline">
        <span class="fa fa-question-circle EnumFormHelp__trigger" @click.prevent="isExpanded = ! isExpanded"></span>
        <div v-show="isExpanded" class="EnumFormHelp__text">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isExpanded: false
            }
        }
    }
</script>

<style lang="scss">
    .EnumFormHelp__trigger {
        display: inline-block;
        margin-left: 10px;
        color: #bbb;
        cursor: pointer;
    }
    .EnumFormHelp__text {
        padding: .5em;
        font-size: .9em;
        color: #999;
    }
</style>
